import React, { useState } from "react";
import "../Navbar/navbar.css";
import guestzaLogoImg from "../../images/guestza_logo.png";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const handleScroll = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <div className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <div className="logo">
          <img src={guestzaLogoImg} alt="Logo" />
        </div>

        {/* Desktop links */}
        <ul className="nav-links">
          <li onClick={() => handleScroll("services")}>Serviços</li>
          <li onClick={() => handleScroll("about")}>Sobre Nós</li>
          <li onClick={() => handleScroll("plans")}>Planos</li>
          <li onClick={() => handleScroll("faqs")}>FAQs</li>
          <li onClick={() => handleScroll("contacts")}>Contactos</li>
        </ul>

        {/* Language selector */}
        <div className="nav-language">
          <span>PT</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </div>

        {/* Hamburger for mobile */}
        <div
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <ul className="nav-links-mobile">
          <li onClick={() => handleScroll("services")}>Serviços</li>
          <li onClick={() => handleScroll("about")}>Sobre Nós</li>
          <li onClick={() => handleScroll("plans")}>Planos</li>
          <li onClick={() => handleScroll("faqs")}>FAQs</li>
          <li onClick={() => handleScroll("contact")}>Contactos</li>
          <li className="lang-mobile">PT / EN</li>
        </ul>
      </div>
    </div>
  );
}